import styled from 'styled-components'
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select  from '@mui/material/Select';
import { categoriasEstado } from '../../../redux/actions/categoriaActions.js';
import Button from '@mui/material/Button';
import api from '../../../axios.js'

const Container = styled.div`
  width: 80%;
  display:flex;
  align-items:center;
  position:relative;

`;

const ContainerAdminCategorias=styled.div`
  position:absolute;
  width:500px;
  height:400px;
  bottom:35px;
  right:15px;
  border-radius:15px;
  transition: all 300ms;
  display:flex;
  flex-direction:column;
  justify-content: space-evenly;
  z-index:3;
  color:white;
  background-color:#262525;
`

export default function Categorias(props) {
  const categoriasRedux = useSelector((state) => state.categoria.categorias); // Todas las categorías disponibles
  const estado = useSelector((state) => state.juego.estadoJuego); // Estado del juego
  const { action, value } = props; // Props que incluyen acción de dispatch y categorías actuales del juego
  const dispatch = useDispatch();
  const [ adminCategoria,setAdminCategoria ]=useState(false);
  const [ data,setData ]=useState([]);
  const [categoriasSeleccionadas, setCategoriasSeleccionadas] = useState([]);// Inicializar el estado con las categorías seleccionadas pasadas por props
  const [deleteCate,setDeleteCate]=useState("")


  

  useEffect(() => {
    if (value) {
      // Convertir las categorías del juego seleccionado en el formato esperado
      const selected = value.map((ele) => ({
        nombre: ele.nombre, // Ajusta según el formato de datos que tienes
        id: ele.id
      }));
      setCategoriasSeleccionadas(selected);
    }
  }, [value]);

  useEffect(()=>{
    let temp=[];
    categoriasRedux.forEach(cate=>{if(cate.activo){temp.push(cate)}})
    setData(temp)
  },[categoriasRedux])



  const onChange = (e, newValue) => {
    // Mapeo de categorías seleccionadas
    const categoriasId = newValue.map((cate) => ({
      nombre: cate.nombre,
      id: cate.id
    }));
    setCategoriasSeleccionadas(categoriasId); // Actualiza el estado local
    dispatch(action({ Categoria: categoriasId })); // Despacha la acción
  };
  
  useEffect(()=>{
    if(estado===2){

      dispatch(action({categorias:categoriasSeleccionadas}));
    }
  },[estado,action,categoriasSeleccionadas,dispatch])



  const handleClick=()=>{
    if(adminCategoria){
      setAdminCategoria(false);       
    }else{dispatch(categoriasEstado(1)); 
       setAdminCategoria(true);
     }
  };

  const selectCategories=(e)=>{
    setDeleteCate(e.target.value)
  };

  const newCategoriaSave=async()=>{
    let nuevaCategoria=document.getElementById("nuevo").value;
    if(window.confirm(`desea grabar ${nuevaCategoria} como una categoria nueva?`)){  
      try{
          await api.post(`/categoria`,{nombre:nuevaCategoria});
          alert(`categoria creada ${nuevaCategoria} es una nueva categoria`);
          setAdminCategoria(false)
          dispatch(categoriasEstado(0))
      }catch(err){console.error(err);alert("error al grabar")}   
    }
  };

  const deleteCategoria=async()=>{
  
    if(window.confirm(`desea eliminar la categoria ?`)){  
      try{
          await api.delete(`/categoria?id=${deleteCate}`);
          alert(`categoria eliminada`);
          setAdminCategoria(false);
          dispatch(categoriasEstado(0));
      }catch(err){console.error(err);alert("error al eliminar")}   
    }
};

  return (
    <Container>
      <Autocomplete
        multiple
        sx={{width:"100%"}}
        id="tags-standard"
        disabled={estado === 0} // Deshabilitar si el estado es 0
        options={data} // Opciones disponibles
        getOptionLabel={(option) => option.nombre} // Mostrar nombre en el listado
        isOptionEqualToValue={(option, value) => option.id === value.id } // Comparación por ID
        value={categoriasSeleccionadas} // Valores por defecto (categorías seleccionadas)
        onChange={onChange}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            label="Categorías"
            placeholder="Seleccionar categorías"
          />
        )}
      />
      <div style={{position:"relative"}}>

      {adminCategoria?<ContainerAdminCategorias>
          <div>
           <b style={{margin:"20px"}}>nueva categoria :</b>
           <TextField sx={{width:"60%"}} id="nuevo" label="nombre categoria nueva" variant="standard" /> 
           <Button color="success" sx={{marginLeft:"20px"}} onClick={newCategoriaSave} variant="text">grabar</Button>
          </div>
         <div>
            <b style={{margin:"20px"}} >eliminar categoria :</b>  
             <Box style={{margin:"20px"}} >
                  <FormControl fullWidth>
                    <InputLabel >{`categorias`}</InputLabel>
                    <Select
                        id="delete"
                        size="small"
                        label={`categorias`}
                        onChange={selectCategories}
                    >
                      {data?data.map((ele)=>(<MenuItem  key={ele.id}  value={ele.id}>{ele.nombre}</MenuItem>)):null}
                    </Select>
                  </FormControl>
              </Box>
              <Button color="error" sx={{marginLeft:"20px"}} onClick={deleteCategoria} variant="text">eliminar</Button>
          </div>
        </ContainerAdminCategorias>:null}

        <LibraryAddIcon sx={{color:"white"}} onClick={handleClick}/>
      </div>
    </Container>
  );
}